export const STEPS = {
  RISK_ANALYSIS: 'riskAnalysis',
  DOCUMENT_ANALYSIS: 'documentAnalysis',
  REVIEW_CRITERIA: 'reviewCriteria',
  SELECTION: 'selection',
  FORMALIZATION: 'formalization',
  TRANSFERENCE: 'transference',
}
